export const ADD_ACCESSORY_SUCCESS = "ADD_ACCESSORY_SUCCESS";
export const LIST_ALL_ACCESSORIES_SUCCESS = "LIST_ALL_ACCESSORIES_REQUEST_SUCCESS";
export const UPDATE_ACCESSORY_SUCCESS = "UPDATE_ACCESSORY_SUCCESS";
export const LIST_ALL_ACCESSORIES_REQUEST = "LIST_ALL_ACCESSORIES_REQUEST";
export const LIST_ALL_ACCESSORIES_FAILURE = "LIST_ALL_ACCESSORIES_FAILURE";
export const DELETE_ACCESSORY_SUCCESS = "DELETE_ACCESSORY_SUCCESS";
export const CREATE_ACCESSORY_SUCCESS = "CREATE_ACCESSORY_SUCCESS";
